module.exports = __webpack_public_path__ + "img/85.f047211c.png";